export default __webpack_public_path__ + "static/media/hi.db433155.jpg";